export default function userInfoObjectCreator(data) {
  return {
    first_name: data.first_name,
    last_name: data.last_name,
    student_id: data.student_id,
    student_no: data.student_no,
    school_name: data.school_name,
    grade: data.grade,
    school_logo: data.school_logo,
    student_photo_url: data.student_photo_url,
    school_code: data.school_code,
    show_id: data.show_id,
    lpass: data.lpass,
  };
}
